export const languageMixin = {
  data: () => ({
    appLang: ''
  }),
  created () {
    this.initLanguage()
  },
  methods: {
    detectUserLanguage () {
      let locale = this.$q.lang.getLocale()

      if (locale !== 'en-US' && locale !== 'es') {
        if (locale.indexOf('en') !== -1) locale = 'en-US'
        else locale = 'es'
      }
      return locale
    },
    setLanguage (locale) {
      const loaders = {
        'es': () => import('quasar/lang/es'),
        'en-US': () => import('quasar/lang/en-US')
      }
      const loader = loaders[locale]
      if (loader) {
        loader().then(lang => { this.$q.lang.set(lang.default) })
      }
      this.$q.lang.locale = locale
      this.$i18n.locale = locale

      this.$q.localStorage.set('binnacle.lang', locale)
    },
    initLanguage () {
      let locale = ''
      if (this.$q.localStorage.has('binnacle.lang')) locale = this.$q.localStorage.getItem('binnacle.lang')
      else locale = this.detectUserLanguage()
      
      this.appLang = locale
    }
  },
  watch: {
    appLang (language) {
      this.setLanguage(language)
    }
  }
}
